import { configureStore, combineReducers } from '@reduxjs/toolkit'
import toastSlice from './toastSlice'
import userProfileReducer from '../components/Desktop/Pages/User/MyAccount/Apis/userProfileSlice'
import teamsSliceReducer from '../components/Desktop/Pages/User/Teams/Apis/teamsSlice'
import landingPageReducer from '../components/Desktop/Pages/LandingPage/Api/landingPageSlice'
import globalErrorsReducer from './globalErrorSlice'
import cartReducer from './cartSlice'
import myStuffReducer from '../components/Desktop/Pages/User/Mystuff/Apis/mystuffSlice'
import myWalletReducer from '../components/Desktop/Pages/User/MyWallet/Apis/myWalletSlice'
import testimonialReducer from '../components/Desktop/Pages/User/Testimonials/Apis/testimonailSlice'
import ticketSliceReducer from '../components/Desktop/Pages/User/Tickets/Apis/ticketSlice'
import withdrawlReducer from '../components/Desktop/Pages/User/Withdrawl/Apis/WithdrawlSlice'

import myEarningsReducer from '../components/Desktop/Pages/User/MyEarnings/APis/myEarningsSlice'

import portfolioReducer from '../components/Desktop/Pages/User/Portfolio/Apis/portfolioSlice'

import dashboardReducer from '../components/Desktop/GlobalComponents/User/Apis/dashboardSlice'
import ordersReducer from '../components/Desktop/Pages/User/Orders/Apis/ordersSlice'

import commonSliceReducer from './commonSlice'
import gamesReducer from '../components/Desktop/Pages/User/Games/Apis/gamesSlice'
import accVerificationReducer from '../components/Desktop/Pages/User/Withdrawl/Apis/AccVarificationSlice'
import productsListingReducer from '../components/Desktop/Pages/ProductListing/Categories/Apis/productListingSlice'
const appReducer = combineReducers({
	toast: toastSlice,
	userProfile: userProfileReducer,
	teams: teamsSliceReducer,
	landingPage: landingPageReducer,
	globalErrors: globalErrorsReducer,
	cart: cartReducer,
	myStuff: myStuffReducer,
	myWallet: myWalletReducer,
	testimonial: testimonialReducer,
	ticket: ticketSliceReducer,
	withdrawl: withdrawlReducer,
	myEarnings: myEarningsReducer,
	portfolio: portfolioReducer,

	dashboard: dashboardReducer,
	orders: ordersReducer,
	login: commonSliceReducer,
	games: gamesReducer,
	accVerification: accVerificationReducer,
	productsListing: productsListingReducer,
})

const rootReducer = (state, action) => {
	if (action.type === 'logout' || action.type === 'signout') {
		state = undefined // This clears the entire state
	}
	return appReducer(state, action)
}

export const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.REACT_APP_ENV !== 'production', //Disabling redux devtools on production
})
